import { normalEmployee } from '../../utils/org-normal'

class OwnerService {
  constructor() {
    this.ownerInfo = null;
  }

  setInfo(data) {
    const user = data && normalEmployee(data);
    if (user && user.mucUid && user.userId && user.userName) {
      this.ownerInfo = user;
    } else {
      this.ownerInfo = null;
    }
  }

  async getInfo(userFn, force) {
    if (!this.ownerInfo || force) {
      let user = await userFn();
      if (user) {
        this.setInfo(user);
      } else {
        this.setInfo(null);
      }
    }
    return this.ownerInfo;
  }
}

export default OwnerService
